'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _oneOf = require('./one-of');
var _oneOf2 = _interopRequireDefault(_oneOf);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function (options) {
  var allowable = options.map(function (option) {
    return option.value;
  });
  return {
    licenceHeld: (0, _oneOf2.default)(allowable, 'Please select how long you have held your licence')
  };
};